/**
 * A campaign's order fields filled from its product, so the planner does not
 * type them again: the batch number from the sequence, the product's name and
 * item number, and the strength the product name carries ("10/325mg").
 */
import { Product } from "../../../../services/products-api";
import { WorkOrderAttributeDefinition } from "../../../../services/work-order-attributes-api";

const UNIT = "(?:mg|mcg|µg|g|ml|mL|%)";
// "10/325mg", "5/7.5/10mg", "0.6mg", "250 mcg", "15mg/5mL".
const STRENGTH = new RegExp(`\\d+(?:\\.\\d+)?(?:\\s*/\\s*\\d+(?:\\.\\d+)?)*\\s*${UNIT}(?:\\s*/\\s*\\d*(?:\\.\\d+)?\\s*${UNIT})?`, "i");

/** The strength written in a product name, or null. */
export const strengthOf = (productName: string): string | null => {
	const match = STRENGTH.exec(productName);
	return match ? match[0].replace(/\s+/g, "") : null;
};

/** What each field can take from the product (only fields it knows; the rest stay empty). */
export function campaignAttributeDefaults(
	definitions: Pick<WorkOrderAttributeDefinition, "attrKey" | "label" | "displaySlot">[],
	product: Pick<Product, "name" | "itemNumber"> | null | undefined
): Record<string, string> {
	const values: Record<string, string> = {};
	definitions.forEach(({ attrKey, label, displaySlot }) => {
		const key = `${attrKey} ${label}`.toLowerCase();
		// The batch number (the card's headline, or a field named for it) — not "PV batch" and the like.
		if (displaySlot === "headline" || /^batch\s*(no|number|#)?$/i.test(attrKey) || /^batch\s*(no\.?|number|#)$/i.test(label.trim())) values[attrKey] = "{seq}";
		else if (!product) return;
		else if (/strength|dose/.test(key)) {
			const strength = strengthOf(product.name);
			if (strength) values[attrKey] = strength;
		} else if (/item|sku|code|material/.test(key)) {
			if (product.itemNumber) values[attrKey] = product.itemNumber;
		} else if (/product/.test(key)) values[attrKey] = product.name;
	});
	return values;
}
